import React, { useContext, useEffect, useState } from "react";
import {useTheme} from "@mui/material";
import {Delete, EditRounded} from "@mui/icons-material";
import {useFieldArray, useForm, FormProvider} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import {eParkingState } from "../../../search-dms/state";
import {updateEparkingInfo} from "../../../search-dms/dmsSearch.actions";
import {AxiosError } from "axios";
import {SET_SNACKBAR} from "../../../common/utils";
import {GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import {FormAutocomplete, FormTextField } from "../../../common/form-fields-wrappers";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../util/state/globalVariables";
import {useHasScope} from "../../../../../config/globalConfig";
import {NetworkScope} from "../../../types";

const EParking = () => {
    const hasScope = useHasScope;
    const {t} = useTranslation(['network', 'translation']);
    const [eParkingInfo, setEParkingInfo] = useRecoilState(eParkingState);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [temp , setTemp] = useState(false);
    const [tempError , setTempError] = useState(false);
    const theme = useTheme();

    const typeList = ["Juice Pole", "Juice Box", "Juice Pump"];
    const [isDisabled, setIsDisabled] = useState(true);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const eParkingInfoForm = useForm({
        defaultValues: {
            id: eParkingInfo?.id,
            chargingStationIdentificationCode: eParkingInfo?.chargingStationIdentificationCode ?? "",
            chargingStationStatus: eParkingInfo?.chargingStationStatus ?? "",
            chargingStationAddress: eParkingInfo?.chargingStationAddress ?? "",
            chargingStationStreetNumber: eParkingInfo?.chargingStationStreetNumber ?? "",
            certificationProtocolIdentifyingCode: eParkingInfo?.certificationProtocolIdentifyingCode ?? "",
            evaluationOutcome: eParkingInfo?.evaluationOutcome ?? "",
            evaluationNote: eParkingInfo?.evaluationNote ?? "",
            effectivePowerOnTheSite: eParkingInfo?.effectivePowerOnTheSite ?? "",
            requiredPowerOnTheSite: eParkingInfo?.requiredPowerOnTheSite ?? "",
            powerOnTheSiteNote: eParkingInfo?.powerOnTheSiteNote ?? "",
            numberOfChargingColumns: eParkingInfo?.numberOfChargingColumns ?? "",
            chargingColumnIdArray: eParkingInfo?.chargingColumnId ?? [],
            chargingColumn: eParkingInfo?.chargingColumn ?? []
        }
    })
    const chargingColumnArray = useFieldArray({ name: 'chargingColumn', control: eParkingInfoForm.control});

    const onError = (errors: any) => {
        setOpen(false);
        dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message: t('translation:error.tryLater'),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
    }

    const onSubmit = (data: any) => {
        const reqParameters = {
            id: eParkingInfo?.id,
            chargingStationIdentificationCode: data.chargingStationIdentificationCode,
            chargingStationStatus: data.chargingStationStatus,
            chargingStationAddress: data.chargingStationAddress,
            chargingStationStreetNumber: data.chargingStationStreetNumber,
            certificationProtocolIdentifyingCode: data.certificationProtocolIdentifyingCode,
            evaluationOutcome: data.evaluationOutcome,
            powerOnTheSiteNote: data.powerOnTheSiteNote,
            effectivePowerOnTheSite: data.effectivePowerOnTheSite,
            requiredPowerOnTheSite: data.requiredPowerOnTheSite,
            evaluationNote: data.evaluationNote ,
            numberOfChargingColumns: data.chargingColumn.lenght,
            chargingColumnId: data.chachargingColumnIdArray,
            chargingColumn: data.chargingColumn
        }
        const isDuplicate = handleControlID(reqParameters.chargingColumn);
        const isIdNull = handleInvalidFields(reqParameters.chargingColumn);
        setTemp(handleControlID(reqParameters.chargingColumn));
        setTempError(handleInvalidFields(reqParameters.chargingColumn));
        if(isDuplicate || isIdNull){
                setOpen(false);
        }
        else{
            //setEParkingInfo(reqParameters);
            updateEparkingInfo(reqParameters)
                .then( (res:any) => {
                    setEParkingInfo(res.eParking);
                })
                .catch((err: AxiosError) => {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }); 
                setIsDisabled(true);
                setOpen(false);
        }
    }

    const handleDisableForm = (value:boolean) => {
        setIsDisabled(value);
    }

    const handleOnDelete = ( index?: number) => {
        chargingColumnArray.remove(index)
    }
    const handleAddColumn = () => {
        chargingColumnArray.append({
            chargingColumnId: "",
            chargingColumnType: "",
            numberOfChargingPoint: ""
        })
    }

    const handleInvalidFields = (arr: any) => {
        const tempArray = arr.map((obj: any) => { return obj.chargingColumnId });
        return tempArray.indexOf("") !== -1;
    }

    const handleControlID = (arr: any) => {
        const tempArray = arr.map((obj: any) => { return obj.chargingColumnId });
        const isDuplicate = tempArray.some((obj: any, index: any) => { 
        return tempArray.indexOf(obj) !== index 
    });
        return isDuplicate
    }

    useEffect(() => {
        eParkingInfoForm.setValue("chargingStationIdentificationCode",eParkingInfo?.chargingStationIdentificationCode);
        eParkingInfoForm.setValue("chargingStationStatus",eParkingInfo?.chargingStationStatus);
        eParkingInfoForm.setValue("chargingStationAddress",eParkingInfo?.chargingStationAddress);
        eParkingInfoForm.setValue("chargingStationStreetNumber",eParkingInfo?.chargingStationStreetNumber);
        eParkingInfoForm.setValue("certificationProtocolIdentifyingCode",eParkingInfo?.certificationProtocolIdentifyingCode);
        eParkingInfoForm.setValue("evaluationOutcome",eParkingInfo?.evaluationOutcome);
        eParkingInfoForm.setValue("evaluationNote",eParkingInfo?.evaluationNote);
        eParkingInfoForm.setValue("effectivePowerOnTheSite",eParkingInfo?.effectivePowerOnTheSite);
        eParkingInfoForm.setValue("requiredPowerOnTheSite",eParkingInfo?.requiredPowerOnTheSite);
        eParkingInfoForm.setValue("powerOnTheSiteNote",eParkingInfo?.powerOnTheSiteNote);
        eParkingInfoForm.setValue("numberOfChargingColumns",eParkingInfo?.numberOfChargingColumns);
        eParkingInfoForm.setValue("chargingColumnIdArray",eParkingInfo?.chargingColumnIdArray);
        eParkingInfoForm.setValue("chargingColumn",eParkingInfo?.chargingColumn);
    },[eParkingInfo])


    return(
        <>
        <FormProvider {...eParkingInfoForm}>
            <Grid container direction="row" alignItems="start" columnSpacing={2}>
                <Grid item xs={12}>
                    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                        {hasScope(NetworkScope.MsMng) && isDisabled &&
                            <IconButton color={"accent"} onClick={() => {handleDisableForm(false)}}>
                                <EditRounded/>
                            </IconButton>
                        }
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="certificationProtocolIdentifyingCode"
                        label={t("dmsDetail.eParking.form.label.perceiverProvince")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled
                        control={eParkingInfoForm.control}
                        name="chargingStationIdentificationCode"
                        label={t("dmsDetail.eParking.form.label.chargingStationIdentificationCode")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled
                        control={eParkingInfoForm.control}
                        name="chargingStationStatus"
                        label={t("dmsDetail.eParking.form.label.chargingStationStatus")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="chargingStationAddress"
                        label={t("dmsDetail.eParking.form.label.chargingStationAddress")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="chargingStationStreetNumber"
                        label={t("dmsDetail.eParking.form.label.chargingStationStreetNumber")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="evaluationOutcome"
                        label={t("dmsDetail.eParking.form.label.evaluationOutcome")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="evaluationNote"
                        label={t("dmsDetail.eParking.form.label.evaluationNote")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="effectivePowerOnTheSite"
                        label={t("dmsDetail.eParking.form.label.effectivePowerOnTheSite")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="requiredPowerOnTheSite"
                        label={t("dmsDetail.eParking.form.label.requiredPowerOnTheSite")}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField
                        disabled={isDisabled}
                        control={eParkingInfoForm.control}
                        name="powerOnTheSiteNote"
                        label={t("dmsDetail.eParking.form.label.powerOnTheSiteNote")}
                    />
                </Grid>

                {isDisabled === false &&
                    <Grid item container xs={12} md={12} justifyContent="flex-end" alignItems="flex-end">
                        <Box sx={{my: theme.spacing(2)}}>
                            <Button variant={'text'} color={"accent"} onClick={handleAddColumn}>
                                {t("dmsDetail.eParking.button.addChargingStation")}
                            </Button>
                        </Box>
                    </Grid>
                }

                    {chargingColumnArray.fields.length === 0 &&
                        <Grid item container xs={12} md={12} align-items="center" justifyContent="center">
                            <p>{t("dmsDetail.eParking.message.emptyState")}</p>
                        </Grid>
                    }
                
                    <Grid item container xs={12} md={12} >
                        {temp === true &&
                        <Grid item container xs={12} md={12}>
                            <Typography sx={{color: theme.palette.error.main}}>
                                {t("dmsDetail.eParking.message.error.duplicateId")}
                            </Typography>
                        </Grid>
                        }
                        {tempError === true &&
                        <Grid item container xs={12} md={12}>
                            <Typography sx={{color: theme.palette.error.main}}>
                                {t("dmsDetail.eParking.message.error.missingID")}
                            </Typography>
                        </Grid>
                        }

                        {chargingColumnArray.fields.map((field, index) => {
                            return (
                                <Grid key={field.id} item container xs={12} md={12} columnSpacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <FormTextField
                                            control={eParkingInfoForm.control}
                                            name={`chargingColumn.${index}.chargingColumnId`}
                                            label={t("dmsDetail.eParking.form.label.chargingColumnId")}
                                            disabled = {isDisabled}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormAutocomplete
                                            name={`chargingColumn.${index}.chargingColumnType`}
                                            control={eParkingInfoForm.control}
                                            options={typeList}
                                            label={t("dmsDetail.eParking.form.label.chargingColumnType")}
                                            disabled = {isDisabled}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormTextField
                                            disabled={isDisabled}
                                            control={eParkingInfoForm.control}
                                            name={`chargingColumn.${index}.numberOfChargingPoint`}
                                            label={t("dmsDetail.eParking.form.label.numberOfChargingPoint")}
                                        />
                                    </Grid>
                                    {isDisabled === false &&
                                        <IconButton sx={{
                                            mt: theme.spacing(2),
                                            ml: 'auto',
                                            mr: theme.spacing(2)
                                        }}
                                            onClick={() => {
                                                handleOnDelete(index)
                                            }}>
                                        <Delete/>
                                        </IconButton>
                                    }
                                </Grid>
                            );
                        })}
                    </Grid>
                <Grid item xs={12}>
                    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                        { !isDisabled ? <Button variant="contained" onClick={handleOpen} >
                            {t("dmsDetail.eParking.button.edit")}
                        </Button> : null }
                    </Stack>
                </Grid> 
            </Grid>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t('dmsDetail.proposalInfo.dialog.title')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('dmsDetail.proposalInfo.dialog.content')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant={"outlined"} color={"accent"}>
                        {t('dmsDetail.proposalInfo.dialog.action.cancel')}
                    </Button>
                    <Button autoFocus onClick={eParkingInfoForm.handleSubmit(onSubmit, onError)}>
                        {t('dmsDetail.proposalInfo.dialog.action.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </FormProvider>
        </>
    )
}

export default  EParking;